import React from "react";

type CheckboxProps = {
  checked: boolean;
  children: string;
  onClick: () => void;
};

const CustomCheckbox = ({ checked, children, onClick }: CheckboxProps) => {
  return (
    <div className="flex my-4">
      <label className="label cursor-pointer" onClick={onClick}>
        <input
          type="checkbox"
          checked={checked}
          className="checkbox border-primary [--chkbg:#282830] [--chkfg:#ffff] checked:border-primary mr-4"
        />
        <div className="text-base">{children}</div>
      </label>
    </div>
  );
};

export default CustomCheckbox;
